<template>
    <footer class="footer bg-light py-4">
            <div class="container">
                <div class="row align-items-center">
                    <div class="col-lg-4 text-lg-start"></div>
                    <div class="col-lg-4 my-3 my-lg-0">
                        <a class="btn btn-info btn-social text-white mx-2" 
                        href="https://www.fb.com/tecdevweb" target="_blank" aria-label="Red de Marca" title="Red de Negocio">
                            <i class="fab fa-facebook-f"></i></a>
                        <a class="btn btn-info btn-social text-white mx-2" href="https://m.me/tecdevweb" target="_blank" title="Dejanos un Mensaje">
                            <i class="fab fa-facebook-messenger"></i></a>                        
                        <a class="btn btn-info btn-social text-white mx-2" href="https://www.youtube.com/@TecWeb-dev" title="Canal de Negocio">
                            <i class="fab fa-youtube"></i></a>
                    </div>
                    <div class="col-lg-4 text-lg-end">Copyright &copy; TecWeb 2025
                    </div>
                </div>
            </div>
        </footer>   
</template>